import { atom, useAtomValue } from 'jotai';
import { FC, useEffect, useRef } from 'react';
import { $PageLevelTraffic } from 'shared/atoms/page-traffic';
import { PageLevelTrafficUtil } from 'shared/models/page-level-traffic';
import { EPageType } from 'shared/models';

const $ReportTime = atom<number>(0);

/**
 * logic component for track wap_pageshow
 *
 * totally listen to $PageLevelTraffic atom
 */
export const PageShowReporter: FC = () => {
  const traffic = useAtomValue($PageLevelTraffic);

  const prevCanonicalUrl = useRef('');
  const count = useRef(0);

  useEffect(() => {
    const { canonicalUrl, pageType } = traffic;
    const pageId = PageLevelTrafficUtil.getPageIdFromTraffic(traffic);
    const with_breadcrumbs = traffic.pageType === EPageType.discover && traffic.hasBreadCrumb;
    const question = (traffic.pageType === EPageType.experience && traffic.question) || '';
    const contentByTranslate =
      (traffic.pageType === EPageType.article || traffic.pageType === EPageType.video) && traffic.contentByTranslate;

    // use canonical url as unique-key
    if (prevCanonicalUrl.current === canonicalUrl) {
      return;
    }
    prevCanonicalUrl.current = canonicalUrl;

    const countByAtom = window.store.get($ReportTime);
    window.Tea('config', {
      seo_page_id: traffic.seoPageId,
      is_new_arch: 1,
      evtParams: {
        current_page_name: pageType,
        page_id: pageId,
        with_breadcrumbs: with_breadcrumbs ? '1' : '0',
        content_by_translate: contentByTranslate,
        question,

        navigation_count: ++count.current,
        navigation_count_by_atom: countByAtom + 1,

        navigator_language: navigator.language,
        navigator_languages: navigator.languages.join(),
      },
    });
    window.store.set($ReportTime, countByAtom + 1);

    window.Tea('wap_pageshow');
  }, [traffic]);

  return null;
};
